/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const ai = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#ai_svg__a)"
    >
      <path d="M10.763 9.041c-3.014 1.016-4.007 2.147-4.742 4.963-.734-2.816-1.728-3.947-4.741-4.963C4.293 8.026 5.287 6.895 6.021 4.08c.735 2.816 1.728 3.947 4.742 4.962Zm3.738-4.697c-1.7.57-2.26 1.205-2.674 2.788-.415-1.583-.975-2.218-2.675-2.788 1.7-.57 2.26-1.206 2.675-2.788.414 1.582.974 2.217 2.674 2.788Zm.221 8.226c-1.258.412-1.673.873-1.98 2.02-.306-1.147-.721-1.607-1.98-2.02 1.259-.414 1.674-.875 1.98-2.021.307 1.146.722 1.607 1.98 2.02Z" />
    </g>
    <defs>
      <clipPath id="ai_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default ai
